import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import FormDatePicker from '../../components/DatePicker';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import { ThemeProvider } from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import MaterialTable from "material-table";
import { Button } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import LossesDataForm from './LossesDataForm';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from "react-redux";


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const api = axios.create({
    baseURL: 'WorkCenterLoss'
})

const apiM = axios.create({
    baseURL: 'MasterDetails'
})

function WorkCenterWiseIdleTime(props) {

    //for progress
    const [openLoader, setopenLoader] = useState(false);

    //function getURLParameter(sParam) {
    //    var sPageURL = window.location.search.substring(1);
    //    var sURLVariables = sPageURL.split('&');
    //    for (var i = 0; i < sURLVariables.length; i++) {
    //        var sParameterName = sURLVariables[i].split('=');
    //        var value = '';
    //        for (var j = 0; j < sParameterName.length; j++) {
    //            if (sParameterName[j] == sParam) {
    //                for (var k = j + 1; k < sParameterName.length; k++) {
    //                    value = value + sParameterName[k];
    //                }
    //                break;
    //            }
    //            else {
    //                continue;
    //            }
    //        }
    //        return value;
    //    }
    //}


    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }

    function getParamName(sParameterName, sParam) {
        var value = '';
        for (var j = 0; j < sParameterName.length; j++) {
            if (sParameterName[j] == sParam) {
                value = value + getParanValue(j, sParameterName);
                break;
            }
            else {
                continue;
            }
        }
        return value;
    }

    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }


    const today = Date.now();
    let newdateformat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(today);
    let ldate = newdateformat.split("/")[2] + "-" + newdateformat.split("/")[0] + "-" + newdateformat.split("/")[1];
    const [entrydate, setentrydate] = useState(ldate);
    const [data, setData] = useState([]); //table data
    //const [entrydate, setentrydate] = useState(new Date());
    const [mrp, setmrp] = useState([]);
    const [mrpValue, setmrpValue] = useState('');
    const [shiftValue, setshiftValue] = useState('');
    const [workCenterLossId, setworkCenterLossId] = useState(window.atob(getURLParameter("ID")) ? window.atob(getURLParameter("ID")) : props.SlipGenId);
    const [EntryNumberValue, setEntryNumberValue] = useState("");
    const [ViewEntryNumberValue, setViewEntryNumberValue] = useState("");
    const [WorkerShift, setWorkerShift] = useState([]);
    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);
    const [isDisabled, setisDisabled] = useState(true);

    //for form editing
    const [isDialogOpen, setisDialogOpen] = useState(false);
    const [editslipDetailsData, seteditslipDetailsData] = useState('');
    const [isSubmitDisabled, setisSubmitDisabled] = useState(true);
    const [isShiftSubmitted, setisShiftSubmitted] = useState(false);
    const [shiftSubmittedMsg, setshiftSubmittedMsg] = useState('');
    const [isFieldDisabled, setisFieldDisabled] = useState(false);
    const [isSaveDraftDisabled, setisSaveDraftDisabled] = useState(true);

    //for alert showing
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    const [alertsuccess] = useState("Success");
    //const [alerterror, setalerterror] = useState("Error");
    const [alertwarning] = useState("Warning");
    //const [alertinfo, setalertinfo] = useState("Information");
    const [alertsuccessclass] = useState("bg-light-green clr-white");
    //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
    const [alertwarningclass] = useState("bg-amber clr-white");
    //const [alertinfoclass, setalertinfoclass] = useState("bg-blue clr-white");

    //for Warning showing
    const [openWarning, setopenWarning] = useState(false);
    const [openAlertWarning, setopenAlertWarning] = useState("");
    const [openClassNameWarning, setopenClassNameWarning] = useState("");
    const [openTypeWarning, setopenTypeWarning] = useState("");

    //for error handling
    const [iserror, setIserror] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])
    const [severity, setSeverity] = useState('success');

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);


    var columns = [
        { title: "WorkCenter", field: "workCenter" },
        { title: "AMH (Worker Loaded)", field: "amh" },
        { title: "Tool Breakdown", field: "toolBreakdown" },
        { title: "Machine Breakdown", field: "machineBreakdown" },
        { title: "Power Failure", field: "powerFailure" },
        { title: "No Operator", field: "noOperator" },
        { title: "No Raw Material", field: "noRawMaterial" },
        { title: "No Tool", field: "noTool" },
        { title: "No Order", field: "noOrder" },
        { title: "Other Losses", field: "otherLosses" },
        { title: "Planned Losses", field: "plannedLosses" },
        { title: "Total Losses", field: "totalLosses" },
        { title: "Total AMH", field: "totalAmh" },
        { title: "Remarks", field: "remarks", hidden: true },
    ]

    function handleClose() {
        setopen(false);
    }

    function handleCloseWarning() {
        setopenWarning(false);
    }

    const handleChangeMrp = (event) => {
        setmrpValue(event.target.value);
    };
    
    const handleChangeShift = (event) => {
        setshiftValue(event.target.value);
    };

    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }
    
    function dateChangeEvent(dateValue, label) {
        if (dateValue !== null) {
            setentrydate(new Date(dateValue));
        }
        else {
            setentrydate(null);
        }
    }

    function editWCLossData(rowData) {
        setisDialogOpen(true);
        seteditslipDetailsData(rowData);
    }

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    function getDataFromDataForm(data) {
        setData(data);
        if (data.length > 0) {
            if (workCenterLossId !== undefined || workCenterLossId === "") {
                let wclid = Number(data[0].workCenterLossId);
                let entryNum = Number(data[0].entryNumber);
                if (wclid > 0) {
                    setworkCenterLossId(wclid);
                    setViewEntryNumberValue('W' + data[0].entryNumber);
                    setEntryNumberValue(entryNum);
                    if (EntryNumberValue === "" || EntryNumberValue === undefined || EntryNumberValue === null) {
                        showMsg(true, "Entry Number W" + data[0].entryNumber + " created successfully.", alertsuccessclass, alertsuccess);
                    }
                    setisFieldDisabled(true);
                }
            }
        }
    }

    const goBackonClick = () => {
        setisDialogOpen(false);
        seteditslipDetailsData('');
    }

    function getMRP() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        apiM.get('/getTblMstMrpcontroller/',{
            headers: headers
        })
            .then(res => {
                setmrp(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. MRP Controller")
            })
    }

    function getShift() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        apiM.get('/getAllEmployeeShift/',{
            headers: headers
        })
            .then(res => {
                setWorkerShift(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. Shift")
            })
    }
        
    function getWorkCenters() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let isValidate = ValidateForm();
        if (isValidate) {
            let wclId = 0;
            if (workCenterLossId !== undefined) {
                wclId = Number(workCenterLossId);
            }
            let customWCLoss = {
                EntryDate: entrydate,
                MrpcontrollerId: mrpValue,
                WorkerShiftId: shiftValue,
                WorkCenterLossId: wclId
            }
            let errorList = [];
            api.post("/getWorkCenterLossesDetails/", customWCLoss,{
                headers: headers
            })
            .then(res => {
               // console.log(res.data);
                if (res.data.length > 0) {
                    if (Number(res.data[0].workCenterLossDetId) > 0 && Number(res.data[0].workCenterLossId) > 0) {
                        //showMsg(true, "Entry Number W" + res.data[0].entryNumber + " already created.", alertinfoclass, alertinfo);
                        errorList.push("Entry Number W" + res.data[0].entryNumber + " already created.");
                        showMessage(errorList, true, 'success');
                        setData([]);
                    }
                    else {
                        setisSaveDraftDisabled(false);
                        setData(res.data);                        
                    }
                }
                else {
                    errorList.push("Data not found");
                    showMessage(errorList, true, 'error');
                    //showMsg(true, "Data not found", alerterrorclass, alerterror);
                    setData([]);
                }
            })
            .catch(error => {
                console.log("Error")
            })
        }        
    }

    function getWorkCenters_ById(mrpValueId, shiftValueId) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let wclId = 0;
        if (workCenterLossId !== undefined) {
            wclId = Number(workCenterLossId);
        }
        let customWCLoss = {
            EntryDate: entrydate,
            MrpcontrollerId: mrpValueId,
            WorkerShiftId: shiftValueId,
            WorkCenterLossId: wclId
        }
        api.post("/getWorkCenterLossesDetails/", customWCLoss,{
            headers: headers
        })
            .then(res => {
                setData(res.data)
                if (wclId > 0) {
                    setopenLoader(false);
                }
            })
            .catch(error => {
                console.log("Error")
            })
    }

    function ValidateForm() {
        let isValidate = true;
        let errorList = [];
        if (mrpValue == "" || mrpValue === null || mrpValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select MRP Controller", alerterrorclass, alerterror);
            errorList.push("Select MRP Controller");
            showMessage(errorList, true, 'error');
        }
        if (shiftValue == "" || shiftValue === null || shiftValue === undefined) {
            isValidate = false;
            //showMsg(true, "Select Shift", alerterrorclass, alerterror);
            errorList.push("Select Shift");
            showMessage(errorList, true, 'error');

        }
        if (entrydate === null || entrydate === undefined) {
            isValidate = false;
            //showMsg(true, "Select Entry Date.", alerterrorclass, alerterror);
            errorList.push("Select Entry Date.");
            showMessage(errorList, true, 'error');

        }
        return isValidate
    }

    function saveWorkCenterLoss() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let isValidate = ValidateForm();
        if (isValidate) {
            setopenLoader(true);
            let tblTrnWorkCenterLossHeader = {
                Id: Number(workCenterLossId),
                EntryNumber: EntryNumberValue,
                EntryDate: entrydate,
                MrpcontrollerId: mrpValue,
                WorkerShiftId: shiftValue,
                CreatedBy: CreatedUserId,
                ModifiedBy: CreatedUserId,
                Status: 1
            }
            let errorList = [];
            api.post("/saveWorkCenterLoss/", tblTrnWorkCenterLossHeader,{
                headers: headers
            })
                .then(res => {
                    //console.log(res.data);
                    setData(res.data);
                    if (res.data.length > 0) {
                        if (workCenterLossId !== undefined || workCenterLossId === "") {
                            let wclid = Number(res.data[0].workCenterLossId);
                            let entryNum = Number(res.data[0].entryNumber);
                            if (wclid > 0) {
                                setworkCenterLossId(wclid);
                                setEntryNumberValue(res.data[0].entryNumber);
                                setViewEntryNumberValue("W" + res.data[0].entryNumber);
                                setisDisabled(false);
                                setisSubmitDisabled(false);
                                setisFieldDisabled(true);  
                                setopenLoader(false);
                                if (EntryNumberValue === "" || EntryNumberValue === undefined || EntryNumberValue === null) {
                                    errorList.push("Entry Number W" + res.data[0].entryNumber + " created successfully.");
                                    //showMsg(true, "Entry Number W" + res.data[0].entryNumber + " created successfully.", alertsuccessclass, alertsuccess);
                                    showMessage(errorList, true, 'success');
                                }
                                else {
                                    errorList.push("Entry Number W" + res.data[0].entryNumber + " updated successfully.");
                                    //showMsg(true, "Entry Number W" + res.data[0].entryNumber + " updated successfully.", alertsuccessclass, alertsuccess);
                                    showMessage(errorList, true, 'success');
                                }
                            }
                        }
                    }                  
                })
                .catch(error => {
                    errorList.push("Something went wrong.");
                    //showMsg(true, "Something went wrong.", alerterrorclass, alerterror);
                    showMessage(errorList, true, 'error');
                    console.log(error);
                    setopenLoader(false);
                })
        }  
    }

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function submitWorkCenterLoss() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenWarning(false);
        let isValidate = ValidateForm();
        if (isValidate) {
            if (data.length > 0) {
                setopenLoader(true);
                let tblTrnWorkCenterLossHeader = {
                    Id: Number(workCenterLossId),
                    EntryNumber: EntryNumberValue,
                    EntryDate: entrydate,
                    MrpcontrollerId: mrpValue,
                    WorkerShiftId: shiftValue,
                    CreatedBy: CreatedUserId,
                    ModifiedBy: CreatedUserId,
                    Status: 2
                }
                let errorList = [];
                api.post("/submitWorkCenterLoss/", tblTrnWorkCenterLossHeader,{
                    headers: headers
                })
                    .then(res => {
                        setopenLoader(false);
                        if (res.data.length === 0) {
                            errorList.push("Entry Number W" + EntryNumberValue + " submitted successfully.");
                            //showMsg(true, "Entry Number W" + EntryNumberValue + " submitted successfully.", alertsuccessclass, alertsuccess);
                            showMessage(errorList, true, 'success');
                            window.location = "/WorkCenterSummary";
                        }
                        else {
                            let msg = "";
                            let sep = "";
                            for (let i = 0; i <= res.data.length - 1; i++) {
                                msg = msg + sep + res.data[i].viewEntryNumber;
                                sep = ", ";
                            }
                            if (msg !== "") {
                                setshiftSubmittedMsg(msg);
                                setisShiftSubmitted(true);
                            }
                        }
                    })
                    .catch(error => {
                        //showMsg(true, "Something went wrong.", alerterrorclass, alerterror);
                        errorList.push("Something went wrong.");
                        showMessage(errorList, true, 'error');
                        console.log(error);
                    })
            }            
        }
    }

    function submitForm() {
        let isValidate = true;
        let workcenter_Greater_480 = "";
        let workcenter_Less_480 = "";
        let sep = "";
        let sep1 = "";
        for (let i = 0; i <= data.length - 1; i++) {
            if (Number(data[i].totalAmh) > 480) {
                workcenter_Greater_480 = workcenter_Greater_480 + sep + data[i].workCenter;
                sep = "<br />";
                isValidate = false;
            }
            if (Number(data[i].totalAmh) < 480) {
                workcenter_Less_480 = workcenter_Less_480 + sep1 + data[i].workCenter;
                sep1 = "<br/ >";
                isValidate = false;
            }
        }
        let workcenter = "";
        if (workcenter_Greater_480 !== "") {
            workcenter = "<b>Work center total AMH greater than 480 : </b> <br />" + workcenter_Greater_480 + "<br />";
        }
        if (workcenter_Less_480 !== "") {
            workcenter = workcenter + "<b>Work center total AMH less than 480 : </b> <br />" + workcenter_Less_480;
        }
        if (isValidate) {
            submitWorkCenterLoss();
        }
        else {
            if (workcenter !== "") {
                setopenWarning(true);
                setopenAlertWarning(workcenter);
                setopenClassNameWarning(alertwarningclass);
                setopenTypeWarning(alertwarning);
            }
        }
    }

    function createMarkup() { return { __html: openAlertWarning }; };

    function search(event) {
        alert(event);
    }

    function getWorkCenterLoss(workcenterlossId) { 
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };       
        api.get('/getWorkCenterLossesHeader/' + workcenterlossId,{
            headers: headers
        })
            .then(res => {
                setmrpValue(res.data.mrpcontrollerId);
                setshiftValue(res.data.workerShiftId);
                setworkCenterLossId(res.data.id);
                setEntryNumberValue(res.data.entryNumber);
                setViewEntryNumberValue("W" + res.data.entryNumber);
                //setentrydate(res.data.entryDate);
                setCreatedUserId(res.data.createdUser);
                let entry = res.data.viewEntryDate.split("/")[2] + "-" + res.data.viewEntryDate.split("/")[1] + "-" + res.data.viewEntryDate.split("/")[0];
                setentrydate(entry);
                setisDisabled(false);
                setisSubmitDisabled(false);

                getWorkCenters_ById(res.data.mrpcontrollerId, res.data.workerShiftId);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. Employee")
            })
    }

    useEffect(() => {
        var id = window.atob(getURLParameter("ID"));
        setworkCenterLossId(id);
        getMRP();
        getShift();
        if (Number(id) > 0) {
            setopenLoader(true);
            setisFieldDisabled(true);
            getWorkCenterLoss(id);
        }
    }, [])

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">WorkCenter Losses Form</h3>
                </Box>

                <Grid container spacing={1} className="d-flex jc-space-bt mt-1">
                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <TextField className="lightInputFields  "
                            id="entryNumber"
                            label="Entry Number"
                            variant="filled"
                            fullWidth
                            name="Entry Number"
                            value={ViewEntryNumberValue}
                            disabled="true"
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl variant="filled" className="reg-form--division-icon custom-pd-bottom" fullWidth>
                            <FormDatePicker
                                id="entrydate"
                                placeholder="*Entry Date"
                                label="  *Entry Date"
                                value={entrydate}
                                onChange={dateChangeEvent}
                                disabled={isFieldDisabled}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl variant="filled" className="reg-form--division-icon" fullWidth>
                            <InputLabel id="demo-simple-select-label">*Shift</InputLabel>                            
                            <Select
                                labelId="demo-controlled-open-select-label"
                                id="demo-controlled-open-select"
                                disabled={isFieldDisabled}
                                value={shiftValue}
                                onChange={handleChangeShift} >
                                {
                                    WorkerShift.map((h, i) =>
                                        (<MenuItem key={i} value={h.shiftId}>{h.shiftName}</MenuItem>))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl variant="filled" className="reg-form--division-icon" fullWidth>
                            <InputLabel id="demo-simple-select-label">*MRP Controller</InputLabel>
                            <Select
                                labelId="demo-controlled-open-select-label"
                                id="demo-controlled-open-select"
                                disabled={isFieldDisabled}
                                value={mrpValue}
                                onChange={handleChangeMrp}
                            >
                                {
                                    mrp.map((h, i) =>
                                        (<MenuItem key={i} value={h.mrpcontrollerId}>{h.mrpcontroller}</MenuItem>))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" disabled={isFieldDisabled} onClick={getWorkCenters}>
                            <span>Get WorkCenters</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" disabled={isSaveDraftDisabled} onClick={saveWorkCenterLoss} >
                            <span>Save Draft</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" disabled={isSubmitDisabled} onClick={submitForm} >
                            <span>Submit</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                    </Grid>
                    {
                        isShiftSubmitted ?
                            (
                                <Grid item xs={12} className="d-flex Width-100 mt-05">
                                    <p className="clr-red">Error: Not all slips for choosen Date & shift are submitted. Please submit following Slips before continuing</p>
                                </Grid>                               
                            ) : <React.Fragment></React.Fragment>
                    }

                    {
                        isShiftSubmitted ?
                            (
                                <Grid item xs={12} className="d-flex Width-100 mb-0">
                                    <p className="clr-red scroll">{ shiftSubmittedMsg }</p>
                                </Grid>
                            ) : <React.Fragment></React.Fragment>
                    }
                    
                    <Grid item xs={12} sm={12} className="d-flex Width-100 jc-flex-end">
                        <LossesDataForm getDataOnSubmit={getDataFromDataForm.bind(this)} WorkCenterLossId={workCenterLossId} isDisabled={props.isDisabled}
                            isDialogOpen={isDialogOpen} editData={editslipDetailsData} clickgoback={goBackonClick} loginuser={props.loginuser}
                            MRPControllerId={mrpValue} WorkerShiftId={shiftValue} EntryDate={entrydate} EntryNumber={EntryNumberValue} />
                    </Grid>
                    {
                        data.length > 0 ?
                            (
                                <Grid item xs={12}>
                                    
                                    <MaterialTable
                                        title=""
                                        columns={columns}
                                        data={data}
                                        icons={tableIcons}
                                        detailPanel={rowData => {
                                            return (
                                                <div className="p-1 ml-1 detail-dashboard">
                                                    <div>Remarks: {rowData.remarks} </div>
                                                </div>
                                            );
                                        }}
                                        options={{
                                            pageSizeOptions: [30, 40, 50],    // rows selection options
                                            pageSize: 30,
                                            maxBodyHeight: 600,
                                            searchAutoFocus: search,
                                        }}
                                        actions={[
                                            rowData => ({
                                                icon: () => <EditOutlinedIcon fontSize="small" />,
                                                tooltip: 'Edit',
                                                onClick: () => editWCLossData(rowData)
                                            })
                                        ]}                            
                                    />
                                </Grid>  
                            ) : <React.Fragment></React.Fragment>
                    }
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess">
                    <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openType}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            {openAlert}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">OK</span>
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openWarning}
                    onClose={handleCloseWarning}
                    aria-labelledby="draggable-dialog-title"
                    id="Submit">
                    <DialogTitle className={openClassNameWarning} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openTypeWarning}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            <div dangerouslySetInnerHTML={createMarkup()} />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={submitWorkCenterLoss} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">Submit</span>
                        </Button>
                        <Button variant="contained" autoFocus onClick={handleCloseWarning} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">Cancel</span>
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}

export default WorkCenterWiseIdleTime;